import React from "react";
import { TextInputField, DropDownField}  from "../../../helpers";
//import  DropDownField  from "../../helpers/DropDownField";
import { gstCalculation } from "../../../utils";
import { useSelector } from "react-redux";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";



const Product = (props)=>{
    let { sellerData, sellerPO, handleOnDeleteProduct,  product, error, index, handleProductChange ,UOMData, productId, productsList, setProductsList } = props

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    //const gstCalculatedValues = gstCalculation(product)
    let isSellerAndPMStateEqual = sellerData?.stateId === sellerPO?.PMState
    
    let gstRates = pmCompanyConfig.GSTRates
    let gstValues = []
    gstRates.map(eachGSTRate => gstValues.push({label: eachGSTRate.toString(), value: eachGSTRate}))

    let tdsOptions = [
        {tdsSectionId: 1, tdsSection: 'No TDS', displayTDSSection: 'No TDS | 0%', tdsValue: 0},
        {tdsSectionId: 2, tdsSection: '194J', displayTDSSection: '194J | 10%', tdsValue: 10},
        {tdsSectionId: 3, tdsSection: '194C', displayTDSSection: '194C | 1%', tdsValue: 1},
        {tdsSectionId: 4, tdsSection: '194Q', displayTDSSection: '194Q | 0.1%', tdsValue: 0.1},
        {tdsSectionId: 5, tdsSection: 'Other', displayTDSSection: 'Other', tdsValue: null},
    ]

    const onDeleteClick =() => {
        handleOnDeleteProduct(product.id)
    }

    const handleChange = async (e) => {
        handleProductChange(product.id, e.target.name, e.target.value)
    }

    const handleTDSSelection = (e) => {
        const updatedProducts = productsList.map(eachProduct => {
            const relatedTDSOption = updatedTDSOptions.find(eachTDS => eachTDS.tdsSectionId === e.target.value)

            if(eachProduct.id === productId){
                return {...eachProduct, tdsSection: relatedTDSOption.tdsSection, tdsSectionId: e.target.value, tdsValue: relatedTDSOption.tdsValue }
            }
            return eachProduct
        })

        setProductsList(updatedProducts)
    }

    const handleTDSValueChange = (e) => {
        const updatedProducts = productsList.map(eachProduct => {
            if(eachProduct.id === productId){
                return {...eachProduct, tdsValue: e.target.value, tdsSection: 'Other' }
            }
            return eachProduct
        })

        setProductsList(updatedProducts)
    }


    const handleOtherTDSCharge = (e) => {
        const updatedProducts = productsList.map(eachProduct => {
            if(eachProduct.id === productId){
                return {...eachProduct, tdsValue: e.target.value }
            }
            return eachProduct
        })

        setProductsList(updatedProducts)
    }

    let updatedTDSOptions = []
    if(sellerData.tdsSection194q){
        updatedTDSOptions = [tdsOptions[3], tdsOptions[4]]
    }else{
        if(sellerData?.panCode?.[3] === "P"){
            if(product?.HSNCode?.slice(0,2) === "99"){
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            }else{
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        }else{
            tdsOptions = tdsOptions.map(eachOpt => {
                if(eachOpt.tdsSection === "194C"){
                    return { ...eachOpt, displayTDSSection: '194C | 2%', tdsValue: 2 }
                }
                return eachOpt
            })

            if(product?.HSNCode?.toString().slice(0,2) === "99"){
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            }else{
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        }
    }

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    return(
        <>
            <div className="">
                <h5 className="mb-1"> Product : {props.index+1} &nbsp;&nbsp;<icon className="pi pi-times" style={{color:"red"}} onClick={onDeleteClick}></icon></h5>
            </div>
            <div className="p-card">
                <div>
                    <div className="grid">
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <TextInputField name="materialId" disabled labelText='Material Id' value={product.materialId} onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <TextInputField name="productName" disabled labelText='Product Name' value={product.productName} onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <TextInputField name="productSpecification" disabled labelText='Product Specification' value={product.productSpecification} onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                            <TextInputField name="UOM" disabled labelText='UOM' value={product?.UOM} />
                        </div>
                        {
                            isHSNEntryAllowed ? 
                            <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                <TextInputField name="HSNCode" labelText='HSN' value={product?.HSNCode} errorMessage={error[`[${index}].HSNCode`]} onChange={handleChange} />
                            </div>
                            :
                            null
                        }
                        {
                            pmCompanyConfig.isTDSAutomated ? 
                            null
                            :
                            <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                <TextInputField name="tdsValue" value={product.tdsValue} labelText='TDS Value' keyfilter={"num"} onChange={(e) => handleTDSValueChange(e)}/>
                            </div>
                        }
                        {/* <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <DropDownField name="tdsSection" options={updatedTDSOptions} value={product.tdsSectionId} optionLabel="displayTDSSection" optionValue="tdsSectionId" labelText="Select TDS" onChange={handleTDSSelection} />
                        </div>
                        {product.tdsSectionId === 5 &&
                            <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                <TextInputField name="otherTDSAmount" value={product.tdsValue} labelText='Other' onChange={handleOtherTDSCharge} keyfilter="num" />
                            </div>
                        } */}
                    </div>
                    <div className="grid">
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                            <TextInputField name="unitPrice"  labelText='Unit Price' value={product.unitPrice} errorMessage={error[`[${index}].unitPrice`]} onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                            <TextInputField name="qty"  labelText='Quantity' value={product.qty} errorMessage={error[`[${index}].qty`]} onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <DropDownField name="GSTRate"  labelText='GST Rate' options={gstValues} optionLabel="label" optionValue="value" value={product?.GSTRate}  onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <TextInputField name="itemAmountBeforeTax"  labelText='Amt. Before Tax'  value={product?.itemAmountBeforeTax} disabled onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <TextInputField name="itemAmountWithTax"  labelText='Amt. After Tax' value={product?.itemAmountWithTax} disabled onChange={handleChange} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Product;